import { Component, effect, OnInit, ViewChild } from "@angular/core";
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterLinkActive,
} from "@angular/router";
import { ToastrService } from "ngx-toastr";

import { GlobalService } from "../../../../shared/services/global.service";
import { LoginService } from "../../../../shared/services/login.service";

import { CommonModule } from "@angular/common";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { NgbModal, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { LaddaModule } from "angular2-ladda";
import * as moment from "moment";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";
import { SharedModule } from "primeng/api";
import { CalendarModule } from "primeng/calendar";
import {
  API_URLS,
  BOARDING_COVER_IMAGE,
  DEFAULT_IMAGE_PATH,
  EMAIL_PATTERN,
  FILE_PATH,
  FIRST_TEN_NUMBERS,
  MOMENT_FORMAT_START_DATE,
  P_CALENDAR_DATE_FORMAT,
  WHOLE_NUMBER_PATTERN,
} from "../../../../config/app.constants";
import { Globals } from "../../../../globals";
import { OutPostModalService } from "../../../../shared/header/outpost-list-modal/out-post-modal.service";
import { OutpostListModalComponent } from "../../../../shared/header/outpost-list-modal/outpost-list-modal.component";
import { HttpinterceptorService } from "../../../../shared/services/httpinterceptor.service";
import { SpinnerComponent2 } from "../../../../shared/spinners/spinner2.component";
import { Utils } from "../../../../shared/utils";
import { ContactUsComponent } from "../../contact-us/contact-us.component";
import { StarRatingComponent } from "../../star-rating/star-rating.component";

declare var $: any;

@Component({
  selector: "app-boarding-services",
  templateUrl: "./boarding-services.component.html",
  styleUrls: ["./boarding-services.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    FormsModule,
    CalendarModule,
    SharedModule,
    NgSelectModule,
    LaddaModule,
    SpinnerComponent2,
    StarRatingComponent,
    NgbTooltip,
    ContactUsComponent,
    ReactiveFormsModule,
    NgxTrimDirectiveModule,
    OutpostListModalComponent,
  ],
})
export class BoardingServicesComponent implements OnInit {
  @ViewChild("checkout") checkout: any;
  spinnerVariable: boolean;

  inwardDate: Date;
  outwardDate: Date;
  minInWardDate: Date;
  maxDate: Date;

  selectedDateArray = [];
  cageTypeGrid = [];

  selectedPetNumber: number = 1;

  isDateSet: boolean = false;
  isFilter: boolean = false;

  filterRanges: object;

  currentPet;
  petTypeId: any;
  petTypeList: any[];

  numberOfPets = FIRST_TEN_NUMBERS;
  filePath = FILE_PATH;
  pCalendarDateFormat: string = P_CALENDAR_DATE_FORMAT;
  defaultImagePath = DEFAULT_IMAGE_PATH;

  submitted: boolean = false;
  requestSentLadda: boolean = false;

  boardingRequestFrom: FormGroup;
  name = new FormControl("", [Validators.required]);
  email = new FormControl("", [
    Validators.required,
    Validators.pattern(EMAIL_PATTERN),
  ]);
  phone_number = new FormControl("", [
    Validators.required,
    Validators.pattern(WHOLE_NUMBER_PATTERN),
    Validators.maxLength(10),
  ]);
  no_pets = new FormControl("", []);
  notes = new FormControl("", [Validators.required]);
  user_id = new FormControl("", []);
  pet_type_id = new FormControl("", []);
  selectedOutpostId;
  selectedOutpost: any = "";

  currentBoardService;
  currentPetImage;
  petImage;
  availableCagesForOutpost = [];
  notAvailableCagesForOutpost = [];
  apiParams = {};
  bookingDiscountList = [];
  maximumnumberOfPets;
  selectedOutPost: any;
  anotherOutpost: any;

  constructor(
    private http: HttpinterceptorService,
    private route: ActivatedRoute,
    private router: Router,
    private globalService: GlobalService,
    private globals: Globals,
    private toasterService: ToastrService,
    public loginService: LoginService,
    private formBuilder: FormBuilder,
    private outpostModalService: OutPostModalService,
    private modalService: NgbModal
  ) {
    let today = new Date();
    today.setDate(today.getDate() + 25);
    this.maxDate = today;

    effect(() => {
      const el = this.outpostModalService.currentBoardService();
      if (el) {
        if (localStorage.getItem("selectedOutpostId")) {
          this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
        }
      }
      this.getOutpostList();
      this.initBoardingRequestFrom();
      if (this.selectedOutpostId && this.petTypeId) {
        this.filter();
        this.getBoardingDiscount();
      }
    });
  }

  ngOnInit() {
    this.minInWardDate = new Date();
    this.minInWardDate.setDate(this.minInWardDate.getDate() + 1); // Tomorrow Date
    this.minInWardDate.setHours(0, 0, 0, 0); // Set time to start of the day

    this.route.params.subscribe((params) => {
      this.petTypeId = params["id"];
      this.getSelectedPetImage();
      this.getMaximumPetCount();

      this.getSession();
      this.getCurrentPetType();

      if (localStorage.getItem("selectedOutpostId")) {
        this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
      }
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.currentBoardService) {
      this.currentBoardService.unsubscribe();
    }
    if (this.currentPetImage) {
      this.currentPetImage.unsubscribe();
    }
  }

  initBoardingRequestFrom() {
    this.boardingRequestFrom = this.formBuilder.group({
      name: this.name,
      email: this.email,
      phone_number: this.phone_number,
      no_pets: this.no_pets,
      notes: this.notes,
      user_id: this.user_id,
      pet_type_id: this.pet_type_id,
      out_post_id: this.selectedOutpostId,
    });
    this.setValueInRequestFrom();
  }

  setValueInRequestFrom() {
    this.boardingRequestFrom.patchValue({
      no_pets: "1",
      pet_type_id: this.petTypeId,
    });
    if (Object.keys(this.globals.currentUser).length) {
      this.boardingRequestFrom.patchValue({
        name: this.globals.currentUser["full_name"].trim(),
        email: this.globals.currentUser["email"],
        phone_number: this.globals.currentUser["phone_no"]
          ? this.globals.currentUser["phone_no"]
          : "",
        user_id: this.globals.currentUser["id"],
      });
    }
  }

  setCages(res) {
    this.availableCagesForOutpost = [];
    this.notAvailableCagesForOutpost = [];
    this.cageTypeGrid = res.data;
    for (const index in this.cageTypeGrid) {
      if (Object.prototype.hasOwnProperty.call(this.cageTypeGrid, index)) {
        if (this.cageTypeGrid[index].size) {
          const data = this.cageTypeGrid[index].size.toString().split(",");
          this.cageTypeGrid[index]["width"] = data[0];
          this.cageTypeGrid[index]["height"] = data[1];
          this.cageTypeGrid[index]["length"] = data[2];
          this.cageTypeGrid[index]["unit"] = data[3];
        }
        let price;
        if (this.cageTypeGrid[index].amount % 1 !== 0) {
          price = this.cageTypeGrid[index].amount.toString().split(".");
          this.cageTypeGrid[index]["doller"] = price[0];
          this.cageTypeGrid[index]["cent"] = price[1];
        } else {
          this.cageTypeGrid[index]["doller"] = this.cageTypeGrid[index].amount;
          this.cageTypeGrid[index]["cent"] = "00";
        }
      }
    }

    for (const cage in this.cageTypeGrid) {
      if (this.cageTypeGrid[cage].is_available_for_outpost) {
        this.availableCagesForOutpost.push(this.cageTypeGrid[cage]);

        for (const cage in this.availableCagesForOutpost) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.availableCagesForOutpost,
              cage
            )
          ) {
            if (
              this.availableCagesForOutpost[cage].outpost_images &&
              this.availableCagesForOutpost[cage].outpost_images.cover_images
            ) {
              this.availableCagesForOutpost[cage]["default_cover_image"] =
                this.availableCagesForOutpost[cage].outpost_images.cover_images;
            } else {
              this.availableCagesForOutpost[cage]["default_cover_image"] =
                this.availableCagesForOutpost[cage].cover_image;
            }
          }
        }
      } else if (!this.cageTypeGrid[cage].is_available_for_outpost) {
        this.notAvailableCagesForOutpost.push(this.cageTypeGrid[cage]);

        for (const cage in this.notAvailableCagesForOutpost) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.notAvailableCagesForOutpost,
              cage
            )
          ) {
            if (
              this.notAvailableCagesForOutpost[cage].outpost_images &&
              this.notAvailableCagesForOutpost[cage].outpost_images.cover_images
            ) {
              this.notAvailableCagesForOutpost[cage]["default_cover_image"] =
                this.notAvailableCagesForOutpost[
                  cage
                ].outpost_images.cover_images;
            } else {
              this.notAvailableCagesForOutpost[cage]["default_cover_image"] =
                this.notAvailableCagesForOutpost[cage].cover_image;
            }
          }
        }
      }
    }
  }

  getCurrentPetType() {
    this.globalService.getPetTypes().subscribe((data) => {
      this.petTypeList = data;
      this.currentPet =
        this.petTypeList[
          this.petTypeList.indexOf(
            this.petTypeList.find(({ id }) => {
              return id == this.petTypeId;
            })
          )
        ];
    });
  }

  getSelectedDays(date) {
    if (!this.outwardDate) {
      if (this.inwardDate) {
        const format = date.day + "/" + (date.month + 1) + "/" + date.year;
        return this.selectedDateArray.includes(format);
      }
    } else {
      const format = date.day + "/" + (date.month + 1) + "/" + date.year;
      return this.selectedDateArray.includes(format);
    }
  }

  onFilterApply() {
    if (this.inwardDate) {
      this.isFilter = true;
      this.filter();
      setTimeout(() => {
        this.isFilter = false;
      }, 500);
    } else {
      this.toasterService.error("Please select Check-In date");
      return false;
    }
  }

  filter() {
    let inward_date;
    let outward_date;
    if (this.inwardDate && this.outwardDate) {
      const inwardDate = Utils.getDateFormat(this.inwardDate);
      const outwardDate = Utils.getDateFormat(this.outwardDate);
      inward_date = inwardDate[1] + "/" + inwardDate[0] + "/" + inwardDate[2];
      outward_date =
        outwardDate[1] + "/" + outwardDate[0] + "/" + outwardDate[2];
    }
    if (this.inwardDate && !this.outwardDate) {
      this.toasterService.error("Please select Check-Out date");
      return false;
    }
    this.spinnerVariable = true;
    this.http
      .post(
        API_URLS.GET_CAGE_TYPE,
        {
          pet_type_id: this.petTypeId,
          no_of_pet: this.selectedPetNumber,
          inward_date: inward_date,
          outward_date: outward_date,
          out_post_id: this.selectedOutpostId,
        },
        false
      )
      .subscribe(
        (response) => {
          if (response.code == "200") {
            this.setCages(response);
            if (response.data && response.data.length > 0) {
              this.setSession();
            }
          }
          this.spinnerVariable = false;
        },
        (error) => {
          this.spinnerVariable = false;
          this.router.navigate(["/"]);
        }
      );
  }

  getSession() {
    if (sessionStorage.getItem("filterRanges")) {
      this.filterRanges = JSON.parse(sessionStorage.getItem("filterRanges"));
      if (this.filterRanges["fromDate"]) {
        this.inwardDate = new Date(this.filterRanges["fromDate"]);
        this.isDateSet = true;
      }
      if (this.filterRanges["toDate"]) {
        this.outwardDate = new Date(this.filterRanges["toDate"]);
        this.selectOutwardDate();
      }
      if (this.filterRanges["totalPets"]) {
        this.selectedPetNumber = this.filterRanges["totalPets"];
      }
      this.filter();
    }
  }

  setSession() {
    if (this.inwardDate) {
      const sessionObject = {
        fromDate: this.inwardDate,
        toDate: this.outwardDate,
        totalPets: this.selectedPetNumber,
      };
      sessionStorage.removeItem("filterRanges");
      sessionStorage.filterRanges = JSON.stringify(sessionObject);
      this.isDateSet = true;
    }
  }

  selectInwardDate() {
    if (this.inwardDate) {
      this.selectedDateArray = [];
      const date = Utils.getDateFormat(this.inwardDate);
      this.selectedDateArray.push(date[0] + "/" + date[1] + "/" + date[2]);
      const expectedOutwardDate = this.addDays(this.inwardDate, 1);
      this.outwardDate = expectedOutwardDate;
      const expectedOutward = Utils.getDateFormat(expectedOutwardDate);
      this.selectedDateArray.push(
        expectedOutward[0] + "/" + expectedOutward[1] + "/" + expectedOutward[2]
      );
      this.checkout.showOverlay(
        this.checkout.inputfieldViewChild.nativeElement
      );
    }
  }

  selectOutwardDate() {
    const inwardDate = Utils.getDateFormat(this.inwardDate);
    const outwardDate = Utils.getDateFormat(this.outwardDate);
    const checkInDate =
      inwardDate[0] + "/" + inwardDate[1] + "/" + inwardDate[2];
    const checkoutDate =
      outwardDate[0] + "/" + outwardDate[1] + "/" + outwardDate[2];
    if (checkInDate == checkoutDate) {
      this.outwardDate = null;
      this.selectInwardDate();
      return false;
    } else {
      const checkInDiff = moment(checkInDate, MOMENT_FORMAT_START_DATE);
      const checkoutDiff = moment(checkoutDate, MOMENT_FORMAT_START_DATE);
      const totalDays = checkoutDiff.diff(checkInDiff, "days");
      this.selectedDateArray = [];
      const date = Utils.getDateFormat(this.inwardDate);
      this.selectedDateArray.push(date[0] + "/" + date[1] + "/" + date[2]);
      for (let i = 1; i <= totalDays; i++) {
        const expectedOutwardDate = this.addDays(this.inwardDate, i);
        const expectedOutward = Utils.getDateFormat(expectedOutwardDate);
        this.selectedDateArray.push(
          expectedOutward[0] +
            "/" +
            expectedOutward[1] +
            "/" +
            expectedOutward[2]
        );
      }
    }
  }

  addDays(date, count) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + count);
    return newDate;
  }

  redirectCageDetails(cageDetail) {
    if (cageDetail.is_available_for_outpost) {
      this.router.navigate([
        "cage_details",
        this.petTypeId,
        cageDetail.slug ? cageDetail.slug : cageDetail.id,
      ]);
    }
  }

  bookCage(cage) {
    let cageId = cage.slug ? cage.slug : cage.id;
    if (this.isDateSet) {
      if (
        this.globals &&
        this.globals?.currentUser &&
        Object.keys(this.globals?.currentUser).length
      ) {
        this.router.navigate(["/cage_booking", this.petTypeId, cageId]);
      } else {
        this.loginService.openLoginModal(
          "login",
          "/cage_booking/" + this.petTypeId + "/" + cageId
        );
      }
    } else {
      this.toasterService.error("Please select Check-In and Check-Out date");
    }
  }

  boardingRequestModal(content) {
    this.openModalContent(content);
  }

  saveRequest() {
    this.submitted = true;
    this.requestSentLadda = true;
    if (this.boardingRequestFrom.valid) {
      this.submitted = false;
      this.http
        .post(
          API_URLS.SENT_BOOKING_REQUEST,
          this.boardingRequestFrom.value,
          true
        )
        .subscribe(
          (response) => {
            this.requestSentLadda = false;
            this.closeModalContent();
            this.boardingRequestFrom.reset();
            this.setValueInRequestFrom();
          },
          (error) => {
            this.requestSentLadda = false;
          }
        );
    } else {
      this.requestSentLadda = false;
      return false;
    }
  }
  onSelect(cageId) {
    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }
    this.apiParams = {
      service_id: cageId,
      service_type: "boarding",
    };

    const modalRef = this.modalService.open(OutpostListModalComponent, {
      size: "xl",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.fromParent = { data: this.apiParams };
    modalRef.componentInstance.closeOutpostModal.subscribe((response) => {
      if (response) {
        this.selectedOutpost = response.title;
        this.selectedOutpostId = response.id;
        this.filter();

        this.storeOutpostIdInLocalStorage();
      }
      window.scrollTo(0, 0);
    });
  }
  storeOutpostIdInLocalStorage() {
    if (localStorage.getItem("selectedOutpostId")) {
      localStorage.removeItem("selectedOutpostId");
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    } else {
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    }
  }
  closeOutpostModal(data) {
    if (data) {
      this.selectedOutpost = data.title;
      this.selectedOutpostId = data.id;
      this.filter();

      this.storeOutpostIdInLocalStorage();
    }
  }
  getSelectedPetImage() {
    this.http
      .post(API_URLS.BOARDING_MENU_IMAGE, { slug: this.petTypeId }, false)
      .subscribe((response) => {
        if (response && response.cover_image) {
          this.petImage = BOARDING_COVER_IMAGE + response.cover_image;
        } else {
          this.petImage =
            "assets/images/boarding-services/boarding-service-banner.jpg";
        }
      });
  }

  getBoardingDiscount() {
    const parser = new DOMParser();
    this.http
      .post(
        API_URLS.BOARDING_DISCOUNT_FOR_SLIDER,
        { out_post_id: this.selectedOutpostId },
        false
      )
      .subscribe((response) => {
        this.bookingDiscountList = response.data;
      });
  }

  getMaximumPetCount() {
    this.http
      .post(
        API_URLS.MAXIMUM_NUM_OF_PETS,
        { pet_type_id: this.petTypeId },
        false
      )
      .subscribe((response) => {
        const responseData = response.max_no_of_pet;

        this.maximumnumberOfPets = Array(responseData)
          .fill(null)
          .map((x, i) => i + 1);
      });
  }
  openModalContent(content) {
    this.modalService.open(content, {
      size: "xl",
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "modal-bg-blue",
    });
  }
  closeModalContent() {
    this.submitted = false;
    this.modalService.dismissAll();
    Utils.enableBodyScroll();
  }
  getOutpostList() {
    this.http.post(API_URLS.GET_OUT_POST_LIST, {}, false).subscribe(
      (res) => {
        this.selectedOutPost = res.data.data.find(
          (data) => data?.id === this.selectedOutpostId
        );
        this.anotherOutpost = res.data.data.find(
          (data) => data?.id !== this.selectedOutpostId
        );
        console.log(this.selectedOutPost);
      },
      (error) => {}
    );
  }
}
